import { makeAutoObservable, runInAction, toJS } from "mobx";
import { PaginationData } from "../../../types/common";
import { Product } from "../../../types/product";
import http from "../../../libs/http";
import appStore from "../../../stores/appStore";

class SearchPageStore {
  products: PaginationData<Product> | undefined = undefined;

  isLoading: boolean = false;

  isAvailableInCity: boolean = false;

  errorOnFetch: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  async searchProducts(
    searchString: string,
    page = 1,
    per_page = 28,
    url?: string
  ) {
    // cancelRequests();

    runInAction(() => {
      this.errorOnFetch = false;
    });

    this.startLoading();
    try {
      if (url) {
        const { data } = await http.get<PaginationData<Product>>(url);
        runInAction(() => {
          this.products = data;
        });
        if (this.isAvailableInCity) {
          await this.getAvailables();
        }
        this.finishLoading();
        return;
      }
      const { data } = await http.get<PaginationData<Product>>(
        `api/products/search`,
        {
          params: {
            page,
            per_page,
            search: searchString,
            city: appStore.selectedCity,
          },
        }
      );
      runInAction(() => {
        this.products = data;
      });
      if (this.isAvailableInCity) {
        await this.getAvailables();
      }
      this.finishLoading();
    } catch {
      runInAction(() => {
        this.errorOnFetch = true;
      });
      this.finishLoading();
    }

  }

  startLoading() {
    runInAction(() => {
      this.isLoading = true;
    });
  }

  finishLoading() {
    runInAction(() => {
      this.isLoading = false;
    });
  }

  async getAvailables() {
    this.startLoading();
    const { data } = await http.post<Product[]>("api/products/availables", {
      products: toJS(this.products?.data),
      city: appStore.selectedCity,
    });

    runInAction(() => {
      if (this.products) {
        // Create a new object to maintain immutability
        this.products = {
          ...this.products,
          data: data,
        };
      }
    });

    this.finishLoading();
  }

  toggleAvailableInCity() {
    runInAction(() => {
      this.isAvailableInCity = !this.isAvailableInCity;
    });
  }
}

export default new SearchPageStore();
